import { useState, useEffect } from "react";
import Api from "../../../../shared/api/api";
import "../../styles/Testimonials.css";

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const data = await Api.getAllAuthor("api/testimonials");
      // Filter featured testimonials for public display
      const featuredTestimonials = data.testimonials.filter((t) => t.featured);
      setTestimonials(featuredTestimonials);
    } catch (err) {
      console.error("Error fetching testimonials:", err);
    }
  };

  return (
    <div className="testimonials">
      {testimonials.map((t) => (
        <div key={t.id} className="testimonial-card">
          <p className="testimonial-text">"{t.content}"</p>
          <p className="testimonial-author">— {t.name}{t.source ? `, ${t.source}` : ""}</p>
        </div>
      ))}
    </div>
  );
}
